import { MeterUploadRowStatus } from "./buildTrialRunRow";
import type { LedgerRowResult } from "./applyLedgerResult";

export type LedgerSummary = {
  ledgered: number;
  failed: number;
  skipped: number;
  total: number;
};

export const computeLedgerSummary = ({
  results,
  skippedRowIds,
}: {
  results: LedgerRowResult[];
  skippedRowIds: string[];
}): LedgerSummary => {
  const ledgered = results.filter(
    r => r.status === MeterUploadRowStatus.Success,
  ).length;
  const failed = results.filter(
    r => r.status === MeterUploadRowStatus.Failed,
  ).length;
  const skipped = skippedRowIds.length;
  return { ledgered, failed, skipped, total: ledgered + failed + skipped };
};

// Rows the operator still has to act on after this attempt: rejected (retryable)
// plus skipped (never sent because they still had trial-run errors).
export const ledgerRemaining = (summary: LedgerSummary): number =>
  summary.failed + summary.skipped;

// The batch is done only when every attempted row ledgered. An empty attempt
// (total === 0) is never "complete" — there was nothing to finalise.
export const isLedgerComplete = (summary: LedgerSummary): boolean =>
  summary.total > 0 && summary.ledgered === summary.total;

export const LedgerOutcome = {
  All: "all",
  Partial: "partial",
  None: "none",
} as const;
export type LedgerOutcomeValue =
  (typeof LedgerOutcome)[keyof typeof LedgerOutcome];

// Which plain-language toast branch to show for this attempt.
export const ledgerOutcome = (summary: LedgerSummary): LedgerOutcomeValue => {
  if (isLedgerComplete(summary)) return LedgerOutcome.All;
  if (summary.ledgered === 0) return LedgerOutcome.None;
  return LedgerOutcome.Partial;
};
